export const STRIPE_ACCOUNT_RESTRICTED_STATUS = 'restricted';
export const STRIPE_ACCOUNT_RESTRICTED_SOON_STATUS = 'restricted_soon';
